import {
  Alert,
  Button,
  Center,
  Paper,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
} from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { api } from '../api';
import { useAuthStore } from '../stores/auth-store';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const setSession = useAuthStore((state) => state.setSession);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const nextPath = searchParams.get('next') === '/amazon' ? '/amazon' : '/files';

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await api.api.api.v1.auth.login.post({ email, password });
      if (response.error || !response.data) {
        setError('Email or password is incorrect.');
        return;
      }
      setSession(response.data.user, response.data.token);
      void navigate(nextPath, { replace: true });
    } catch {
      setError('The server could not be reached. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <Center mih='100vh' className='login-canvas' p='md'>
      <Paper withBorder shadow='xl' radius='lg' p={36} w='100%' maw={430}>
        <Stack gap='lg'>
          <div>
            <div className='login-icon'>
              <IconLock size={25} />
            </div>
            <Title order={1} mt='md'>
              Welcome back
            </Title>
            <Text c='dimmed' mt={6}>
              Sign in with the account created for you by your administrator.
            </Text>
          </div>
          {error && (
            <Alert color='red' variant='light'>
              {error}
            </Alert>
          )}
          <form onSubmit={submit}>
            <Stack>
              <TextInput
                label='Email address'
                type='email'
                autoComplete='email'
                required
                value={email}
                onChange={(event) => setEmail(event.currentTarget.value)}
              />
              <PasswordInput
                label='Password'
                autoComplete='current-password'
                required
                value={password}
                onChange={(event) => setPassword(event.currentTarget.value)}
              />
              <Button type='submit' loading={loading} mt='sm' size='md'>
                Sign in
              </Button>
            </Stack>
          </form>
          <Text size='xs' c='dimmed' ta='center'>
            Accounts are provisioned directly on the company server.
          </Text>
        </Stack>
      </Paper>
    </Center>
  );
}
